<template>
  <div class="d-radio">
    <label
      :class="{ active: radio.value === value }"
      :for="radio.value"
      v-for="(radio, i) in options"
      :key="i"
    >
      <input
        type="radio"
        :id="radio.value"
        :name="name"
        :value="radio.value"
        :checked="radio.value === value"
        @change="getCurrentValue(radio.value)"
      />
      <template v-if="isText ? isText : ''">
        {{ radio.name }}
      </template>
      <template v-if="isIcon ? isIcon : ''">
        <b-icon
          :icon="radio.icon"
          style="font-size: 1.2rem;"
          aria-hidden="true"
        ></b-icon>
      </template>
    </label>
  </div>
</template>

<script>
export default {
  name: "dashboard-radio",
  props: {
    value: {
      required: true,
    },
    name: {
      type: String,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isText: {
      type: Boolean,
      default: true,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getCurrentValue(value) {
      return this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
$class: ".d-radio";
$corner-radius: 6px;

#{$class} {
  display: flex;
  align-items: center;
  justify-content: center;

  label {
    display: flex;
    position: relative;
    padding: 5px;
    margin-bottom: 0;
    overflow: hidden;
    border: 1px solid $border-color;
    margin-left: -1px;
    background-color: $white;
    color: $border-color;
    cursor: pointer;

    &.active {
      border-color: $primary;
      background-color: $primary;
      z-index: 1;
    }

    &:first-child {
      border-top-left-radius: $corner-radius;
      border-bottom-left-radius: $corner-radius;
    }

    &:last-child {
      border-top-right-radius: $corner-radius;
      border-bottom-right-radius: $corner-radius;
    }

    input[type="radio"] {
      position: absolute;
      left: -9999px;
    }

    .win-icon {
      margin-left: 0;
      margin-right: 0;
    }
  }
}
</style>
